import React from 'react';
import { useTranslation } from 'react-i18next';
import { Input, Option, Select } from '../../../../_lib/Form2';
import type { AttributeNameParam, ConditionParam, ConditionValueParam } from '../AttributeGroupForm.types';
import { createCollectionName } from '../../../../_lib/Form2/types/CollectionParam';

export type AttributeGroupFormRuleProps = {
  attributeName?: AttributeNameParam;
  condition?: ConditionParam;
  conditionValue?: ConditionValueParam;
  initWithEmptyValues?: boolean;
  collectionName: string;
  index: number;
};

export function AttributeGroupFormRule({
  attributeName,
  condition,
  conditionValue,
  collectionName,
  index,
  initWithEmptyValues,
}: AttributeGroupFormRuleProps) {
  const { t } = useTranslation('AttributeGroups');

  if (!attributeName || !condition || !conditionValue) {
    return null;
  }

  const formFieldClassName = 'attribute-group-form__field';

  return (
    <>
      <div className={formFieldClassName}>
        <Select
          label={t('form.ruleset.attribute')}
          param={attributeName}
          name={createCollectionName(collectionName, index, attributeName.name)}
          defaultValue={initWithEmptyValues ? undefined : attributeName.value}
        >
          {attributeName.options
            .map(option => ({ value: option.value, label: t(`PersonAttributes:${option.value}`) }))
            .sort((a, b) => (a.label > b.label ? 1 : -1)) // sort by translated label
            .map(option => (
              <Option key={option.value} label={option.label} value={option.value}>
                {option.label}
              </Option>
            ))}
        </Select>
      </div>
      <div className={formFieldClassName}>
        <Select
          label={t('form.ruleset.condition.label')}
          param={condition}
          name={createCollectionName(collectionName, index, condition.name)}
          defaultValue={initWithEmptyValues ? undefined : condition.value}
        >
          {condition.options.map(option => (
            <Option key={option.value} label={t(`form.ruleset.condition.${option.value}`)} value={option.value}>
              {t(`form.ruleset.condition.${option.value}`)}
            </Option>
          ))}
        </Select>
      </div>
      <div className={formFieldClassName}>
        <Input
          label={t('form.ruleset.value')}
          param={conditionValue}
          name={createCollectionName(collectionName, index, conditionValue.name)}
          defaultValue={initWithEmptyValues ? undefined : conditionValue.value}
        />
      </div>
    </>
  );
}
